module.exports = __webpack_public_path__ + "img/presente.f619e3d2.svg";